<template>
  <ul>
    <MenuCategoryItem
      v-for="category in categoriesStore.getCategories"
      :key="category.code"
      :category="category"
      @close-mobile-menu="$emit('close-mobile-menu')"
    />
  </ul>
</template>

<script setup>
import { useCategoriesStore } from "@/stores/categoriesStore"
import MenuCategoryItem from "./MenuCategoryItem.vue"

defineEmits({
  "close-mobile-menu": null,
})

const categoriesStore = useCategoriesStore()
</script>

<style lang="scss" scoped></style>
